import { render, staticRenderFns } from "./TheBuyNewCreditsPanel.vue?vue&type=template&id=e4efb8f0&scoped=true"
import script from "./TheBuyNewCreditsPanel.vue?vue&type=script&lang=js"
export * from "./TheBuyNewCreditsPanel.vue?vue&type=script&lang=js"
import style0 from "./TheBuyNewCreditsPanel.vue?vue&type=style&index=0&id=e4efb8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4efb8f0",
  null
  
)

export default component.exports